import { useEffect, useState } from "react";
import { Loader2, Send, FileText, Link2, Check } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";

const B = process.env.REACT_APP_BACKEND_URL;

export const PromoThumb = ({ p, size = "w-12 h-12" }) => {
  const [bad, setBad] = useState(false);
  return p.file?.is_image && !bad ? <img src={p.file.url.startsWith("http") ? p.file.url : `${B}${p.file.url}`} alt="" onError={() => setBad(true)} className={`${size} rounded-md object-cover bg-slate-100 shrink-0`} />
    : <div className={`${size} rounded-md bg-amber-50 text-amber-600 flex items-center justify-center shrink-0`}>{p.file ? <FileText className="w-5 h-5" /> : <Link2 className="w-5 h-5" />}</div>;
};

export const PromoPicker = ({ target, suggested = "" }) => {
  const [list, setList] = useState(null);
  const [sel, setSel] = useState(suggested);
  useEffect(() => { setSel(suggested); }, [suggested]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/api/promotions").then(r => setList(r.data.filter(p => p.active))).catch(() => setList([])); }, []);
  const send = async () => {
    setBusy(true);
    try { const { data } = await api.post("/api/callcenter/send-promo", { ...target, promo_id: sel }); (data.partial ? toast.warning : toast.success)(data.message); setSel(""); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  if (!list) return <Loader2 className="w-5 h-5 animate-spin text-slate-400 mx-auto" />;
  if (!list.length) return <p className="text-xs text-slate-400 text-center py-3" data-testid="qs-promos-empty">No promotions yet — an admin can add them in Marketing → Promotions.</p>;
  return (
    <div className="space-y-2" data-testid="qs-promos">
      <div className="max-h-64 overflow-y-auto space-y-1.5 pr-0.5">{list.map(p => (
        <button key={p.id} onClick={() => setSel(sel === p.id ? "" : p.id)} className={`w-full text-left flex gap-2 p-2 rounded-lg border transition-colors ${sel === p.id ? "border-blue-600 bg-blue-50" : "border-slate-200 hover:border-blue-300"}`} data-testid={`qs-promo-${p.id}`}>
          <PromoThumb p={p} />
          <div className="min-w-0 flex-1"><p className="text-sm font-semibold text-slate-900 truncate">{p.title}{p.id === suggested && <span className="ml-1.5 text-[9px] uppercase bg-amber-100 text-amber-700 px-1 rounded" data-testid="qs-promo-suggested">Campaign pick</span>}</p><p className="text-xs text-slate-500 line-clamp-2">{p.message || p.links?.[0]?.url}</p></div>
          {sel === p.id && <Check className="w-4 h-4 text-blue-600 shrink-0" />}
        </button>))}</div>
      <button disabled={!sel || !target.channels.length || busy} onClick={send} className="w-full bg-blue-600 hover:bg-blue-500 disabled:opacity-40 text-white font-bold py-2 rounded-lg flex items-center justify-center gap-1.5 text-sm" data-testid="qs-promo-send">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}{sel ? "Send promotion" : "Pick a promotion"}</button>
    </div>
  );
};
